import { OrgMemberWithProfile } from '@/features/org/api/get-org-members';
import { ProjectCategory } from '@/features/projects/shared/types/category';
import { supabase } from '@/lib/supabase';
import { getDeeplinkPrefix } from '@/shared/utils/deeplink-prefix';

export interface AcceptSubprojectInvitationInput {
  orgId: number;
  invitationToken: string;
  subprojectName: string;
  subprojectDescription?: string;
  contactPerson: string;
  selectedCategory?: ProjectCategory;
  selectedSubcategory?: ProjectCategory;
  kpiBudgets?: Record<number, number | null>;
  invitedMembers?: OrgMemberWithProfile[];
}

export const acceptSubprojectInvitation = async (
  input: AcceptSubprojectInvitationInput,
): Promise<number> => {
  const { data, error } = await supabase.rpc('accept_subproject_invitation', {
    p_invitation_token: input.invitationToken,
    p_view_json: {
      org_id: input.orgId,
      custom_name: input.subprojectName,
      description: input.subprojectDescription,
      category_id: input.selectedCategory?.id,
      sub_category_id: input.selectedSubcategory?.id,
      contact_person: input.contactPerson,
      deeplink_prefix: getDeeplinkPrefix(),
      invited_members: input.invitedMembers,
      budgets: input.kpiBudgets,
    },
  });

  if (error) {
    throw error;
  }

  return data;
};
